import { RefreshResult } from "@idw-types/common";

export enum AxnConfigActionTypes {
    SET_AXN_CONFIG_REFRESHING = "SET_AXN_CONFIG_REFRESHING",
    SET_AXN_CONFIG_REFRESH_RESULTS = "SET_AXN_CONFIG_REFRESH_RESULTS"
}

type SetAxnConfigRefreshingAction = {
    type: AxnConfigActionTypes.SET_AXN_CONFIG_REFRESHING,
    payload: { isRefreshing: boolean; }
};

export const setAxnConfigRefreshing = (isRefreshing: boolean): SetAxnConfigRefreshingAction => ({
    type: AxnConfigActionTypes.SET_AXN_CONFIG_REFRESHING,
    payload: { isRefreshing }
});

type SetAxnConfigRefreshResultAction = {
    type: AxnConfigActionTypes.SET_AXN_CONFIG_REFRESH_RESULTS,
    payload: { refreshResults: Array<RefreshResult>; lastRefreshDate: Date; }
}

export const setAxnConfigRefreshResults = (refreshResults: Array<RefreshResult>, lastRefreshDate: Date): SetAxnConfigRefreshResultAction => ({
    type: AxnConfigActionTypes.SET_AXN_CONFIG_REFRESH_RESULTS,
    payload: { refreshResults, lastRefreshDate }
});


export type AxnConfigActions =
    SetAxnConfigRefreshingAction |
    SetAxnConfigRefreshResultAction